import React, { useEffect, useState } from "react"
import ArticleAutopauta from "../../../shared/components/atoms/article-autopauta/article-autopauta"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import CommentsArticle from "../../../shared/components/molecules/comments-articles/comments-articles"
import FavoriteProducts from "../../../shared/components/molecules/favorite-products/favorite-products"
import MagazineService from "../../../shared/services/magazine"
import { siteUrl } from "../../../shared/utils/siteUrl"
import ArticleGeneric from "../../molecules/article-generic/article-generic"
import ArticleSteps from "../../molecules/article-steps/article-steps"
import ArticleVideo from "../../molecules/article-video/article-video"
import ContentHeaderArticles from "../../molecules/content-header-articles/content-header-articles"
import InteractionArticle from "../../molecules/interaction-article/interaction-article"
import SectionArticleRecommended from "../../molecules/section-article-recommended/section-article-recommended"
import FloatSustainabilityCardMB from "../../../shared/components/atoms/float-sustainability-card-mb/float-sustainability-card-mb"

import "./content-article-fc.scss"
import { graphql, useStaticQuery } from "gatsby"

const ContentArticleFC = props => {
  const { infoArticle, setModalState, updatedAt } = props

  const resultQuery = useStaticQuery(
    graphql`
      query FC_CHAT_BUTTON_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            codigoIcu
            tieneTienda
          }
        }
      }
    `
  )

  const haveShop = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].tieneTienda

  const [barScrollActive] = useState(false)
  // const [activeCategorySlug, setCategorySlug] = useState('');
  const [activeCategoryTitle, setCategoryTitle] = useState("")

  const [heightWindow, setHeight] = useState(0)
  const [percentWidht, setPercent] = useState(0)
  const [savedArticles, setsavedArticles] = useState([])
  const [isLog, setisLog] = useState(false)

  const homeLink = siteUrl + "/entre-nosotras/"
  const rootLink = siteUrl + "/"

  if (props.infoArticle.tipoDeArticulo !== null) {
    var articleType = props.infoArticle.tipoDeArticulo
  }

  const calculateWidht = (hWindow, scroll) => {
    setPercent(Math.round((scroll / (hWindow - 767)) * 100))
  }

  // const savedRedirect = () => {
  //     window.location.href = homeLink + 'guardados/'
  // }

  useEffect(() => {
    // setCategorySlug(sessionStorage.getItem("slugFilter"));
    setCategoryTitle(sessionStorage.getItem("titleFilter"))
    setHeight(document.documentElement.scrollHeight)
    calculateWidht(heightWindow, props.scrollValue)

    if (localStorage.getItem("TOKEN_INFO") !== null) {
      setisLog(true)
      sessionStorage.setItem("LAST_SAVED_ARTICLE", window.location.pathname)

      if (localStorage.getItem("SAVED_ARTICLES") !== null) {
        setsavedArticles(JSON.parse(localStorage.getItem("SAVED_ARTICLES")))
      }
    } else {
      sessionStorage.setItem("NEXT_PAGE", "/entre-nosotras/" + infoArticle.slug)
    }
  }, [])

  const handleSave = (e, payload) => {
    e.preventDefault()

    if (isLog) {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      const savePayload = {
        cmsId: payload.id,
        state: "GUARDADO",
      }

      MagazineService.saveArticle(config, savePayload)
        .then(res => {
          if (res.status === 200) {
            if (localStorage.getItem("SAVED_ARTICLES") === null) {
              localStorage.setItem("SAVED_ARTICLES", JSON.stringify([payload]))
              setsavedArticles([payload])
            } else {
              let copyList = savedArticles
              let newList = copyList.concat([payload])
              setsavedArticles(newList)
              localStorage.setItem("SAVED_ARTICLES", JSON.stringify(newList))
            }
            window.location.href = rootLink + "guardados/#saved"
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      setModalState()
    }
  }

  const handleUnSave = (e, id) => {
    e.preventDefault()

    let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }

    const savePayload = {
      cmsId: id,
      state: "ELIMINADO",
    }

    MagazineService.saveArticle(config, savePayload)
      .then(res => {
        if (res.status === 200) {
          let copyList = savedArticles
          let newList = copyList.filter(a => a.id !== id)
          setsavedArticles(newList)
          localStorage.setItem("SAVED_ARTICLES", JSON.stringify(newList))
        } else {
          console.log(res)
        }
      })
      .catch(e => console.log(e))
  }

  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ]
  const getDate = date => {
    var dateForm = new Date(date)
    return dateForm.getDate() + " de " + monthNames[dateForm.getMonth()] //+ " de " + dateForm.getFullYear()
  }

  var isBrowser = typeof window !== "undefined"
  var path = isBrowser ? window.location.pathname : ""
  var pathElement = path.split("/")

  var sitioPadre = isBrowser
    ? pathElement[pathElement.length - 1] !== ""
      ? pathElement[pathElement.length - 2]
      : pathElement[pathElement.length - 3]
    : ""

  return (
    <div className="f-article-details">
      {!props.mobile && articleType === "Genérico" && (
        <div
          className={
            "f-progressbar " +
            (props.scrollValue > 10 ? "f-progressbar-active" : "")
          }
          style={{ width: percentWidht + "%" }}
        />
      )}

      <ContentHeaderArticles
        infoArticle={props.infoArticle}
        sitioPadre={sitioPadre}
        mobile={props.mobile}
      />

      <div className="f-breadcrum-position">
        <Breadcrumb mobile={props.mobile} />
      </div>

      {props.mobile != null && (
        <InteractionArticle
          idArticle={props.infoArticle.contentful_id}
          item={infoArticle}
          mobile={props.mobile}
          barScrollActive={barScrollActive}
          scrollValue={props.scrollValue}
          setModalState={setModalState}
          savedArticles={savedArticles}
          handleSave={handleSave}
          handleUnSave={handleUnSave}
          updatedAt={updatedAt}
          isLog={isLog}
        />
      )}

      <div className="f-article-content-container">
        <div className="f-article-content-header">
          <a href={homeLink}>
            <span className="f-backbutton-article">
              <span className="f-icon icon-left f-icon-back"></span>
              <span className="f-regular">Volver a</span>
              <span className="f-bold">{activeCategoryTitle}</span>
            </span>
          </a>
          {props.mobile && (
            <h1 className="f-article-title-mobile">
              {props.infoArticle.title}
            </h1>
          )}

          <div className="f-author-date-container">
            <div className="f-left-section">
              <img
                className="f-creator-img"
                src={props.infoArticle.imagenCreadorArticulo.file.url}
                alt={props.infoArticle.imagenCreadorArticulo.description}
              />
              <label className="f-creator-name">
                {props.infoArticle.nombreCreadorArticulo}
              </label>

              <span className="f-check-container">
                <span className="f-icon icon-check-2" />
              </span>
            </div>
            <div className="f-right-section">
              <span className="f-date-update">{getDate(props.updatedAt)}</span>
            </div>
          </div>
        </div>
      </div>

      {props.infoArticle !== null ? (
        articleType === "Genérico" ? (
          <ArticleGeneric
            urlPodcast={props.infoArticle.urlPodcast}
            podcast={props.infoArticle.podcast}
            contentArticle={props.infoArticle.contenidoArticulo}
            // images = {props.infoArticle.contenidoArticulo.imagenes}
            mobile={props.mobile}
            nextPag={props.infoArticle.nextPag}
            prevPag={props.infoArticle.prevPag}
            slugPrefix={"/entre-nosotras/"}
          />
        ) : articleType === "Video" ? (
          <ArticleVideo
            urlPodcast={props.infoArticle.urlPodcast}
            podcast={props.infoArticle.podcast}
            contentArticle={props.infoArticle.contenidoArticulo}
            video={props.infoArticle.video}
            // images = {props.infoArticle.contenidoArticulo.imagenes}
            mobile={props.mobile}
            nextPag={props.infoArticle.nextPag}
            prevPag={props.infoArticle.prevPag}
            slugPrefix={"/entre-nosotras/"}
          />
        ) : articleType === "Paso a paso" ? (
          <ArticleSteps
            urlPodcast={props.infoArticle.urlPodcast}
            podcast={props.infoArticle.podcast}
            mobile={props.mobile}
            pasos={props.infoArticle.referenciasPasoAPaso}
            nextPag={props.infoArticle.nextPag}
            prevPag={props.infoArticle.prevPag}
            slugPrefix={"/entre-nosotras/"}
          />
        ) : null
      ) : null}

      {process.env.LOCALE === "es-CO" ?
        (
          <FloatSustainabilityCardMB />
        )
        :
        (
          props.mobile && props.infoArticle.autopauta !== null && (
            <section className="f-section-mobile-autopauta">

              <div
                className={
                  "f-article-autopauta-container " +
                  (typeof props.infoArticle.autopauta[1] !== "undefined"
                    ? "with-bottom "
                    : "")
                }
              >
                <ArticleAutopauta
                  infoAutopauta={props.infoArticle.autopauta[0]}
                  slugPrefix={"/entre-nosotras/"}
                />
              </div>

              {typeof props.infoArticle.autopauta[1] !== "undefined" && (
                <div
                  className={
                    "f-bottom-autopauta " +
                    (props.infoArticle.autopauta[1].tipoDeAutopauta ===
                      "Artículos Relacionados"
                      ? "no-flex "
                      : "")
                  }
                >
                  <ArticleAutopauta
                    infoAutopauta={props.infoArticle.autopauta[1]}
                    slugPrefix={"/entre-nosotras/"}
                  />
                </div>
              )}
            </section>
          )
        )
      }



      {props.infoArticle.recomendadosParaTi !== null && (
        <SectionArticleRecommended
          mobile={props.mobile}
          recomendados={props.infoArticle.recomendadosParaTi}
        />
      )}
      <CommentsArticle
        idArticle={props.infoArticle.contentful_id}
        slug={props.infoArticle.slug}
        setModalState={setModalState}
      />

      {haveShop && <FavoriteProducts mobile={props.mobile} />}
    </div>
  )
}

export default ContentArticleFC
